var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m8.805 11.818 3.657 5.933c.16.26.41.257.51.243a.508.508 0 0 0 .433-.371l4.573-15.445a.522.522 0 0 0-.133-.525.512.512 0 0 0-.512-.132L1.877 6.047a.51.51 0 0 0-.371.433.515.515 0 0 0 .24.52l6.002 3.754 5.302-5.358a.751.751 0 0 1 1.067 1.055l-5.312 5.367Zm4.09 7.682a1.997 1.997 0 0 1-1.71-.962l-3.877-6.291L.952 8.272A2.004 2.004 0 0 1 .02 6.276a2 2 0 0 1 1.435-1.668L16.91.082a2.02 2.02 0 0 1 2.504 2.522l-4.573 15.444a1.997 1.997 0 0 1-1.67 1.433 2.173 2.173 0 0 1-.277.019Z",
    clipRule: "evenodd"
  })));
};
export default SvgSend;